import * as React from "react";
import { hot } from "react-hot-loader";
import DataProviderSharePoint from '../../../dataproviders/DataProvidersSharePoint';
import { IInputFormSharePoint } from '../../../interfaces/IInputFormSharePoint';
import CustomInput from '../../CustomInput/CustomInput';
import { CustomInputService } from '../../CustomInput/CustomInputService';
import { IFormulaireInputProps } from './IFormulaireInputProps';
import { IFormulaireInputState } from './IFormulaireInputState';
declare var libelle: any;

class FormulaireInput extends React.Component<IFormulaireInputProps, IFormulaireInputState> {

    private _dataProvider = new DataProviderSharePoint();

    constructor(props: IFormulaireInputProps) {
        super(props);

        // Init du state
        this.state = {
            IsValidForm: false,
            IsFirstSubmit: true,
            IsReady: false,
            InputState: this.props.InputFormSharePoint,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.initListePCS = this.initListePCS.bind(this);
    }

    public componentDidMount() {
        this.firstValidationFormInputSharePoint();
    }

    public render() {

        return (

            this.state.IsReady && this.state.InputState.IsVisible &&
            <div>
                <form className="pt-1" noValidate={true} onSubmit={this.handleSubmit}>
              <CustomInput HandleChange={this.handleChange} HandleBlur={this.handleBlur} HandleCheck={this.handleCheck}
                InputForm={this.state.InputState} IsFirstSubmit={this.state.IsFirstSubmit} HandleChangeDate={this.handleChangeDate} InitListePCS={this.initListePCS} />
                </form>
            </div>
        );
    }

    // EL : Méthode permettant d'initialiser les champs PCS
    // -> récupération de la valeur saisie dans la liste PCS de niveau 1 (ProfPCSParent*)
    // -> intialisation des valeurs de la listes PCS de niveau 2 (FonctionPCSParent*)
    // -> gestion du critère obligatoire sur le bloc PCS
    private initListePCS(InputListeSP:string[]): string[] {
        let valeursSP: string[] = [];
        this.props.InputFormSharePoint.IsValid = true;

        InputListeSP.map(listeSP => {
            const inputSP: IInputFormSharePoint = this.props.InputFormSharePointList[listeSP];
            if (inputSP != null) {
                valeursSP.push(inputSP.Value);
                if (inputSP.Value == null || inputSP.Value == "") {
                  this.props.InputFormSharePoint.IsValid = false;
                }
            }
        });

        CustomInputService.validInput(this.props.InputFormSharePoint, "", this.props.InputFormSharePointList);
      
        return valeursSP;
    }

    // EL : ajout de la gestion des liste PCS (enregistrement des champs SP des listes PCS ProfPCSParent* et FonctionParent*)
    // EL : gestion de l'affichage conditionnel déclenché par des sélections de valeur dans des champs de type liste
    private handleCheck(event) {
        if (this.state.InputState.IsReadOnly) {
            return;
        }

        const inputState = this.state.InputState;
        inputState.Value = event.target.value;
        this.setState({ InputState: inputState });
        this.inputHaveShowingOther();

        if (this.state.InputState.Type == "TaxonomyFieldType") {
            // Gestion du critère obligatoire du bloc PCS
            this.state.InputState.IsValid = event.target.value == "" ||
                event.target.name == "ProfPCSParent1" || event.target.name == "ProfPCSParent2" ? false : true;            
            CustomInputService.validInput(this.state.InputState, event.target.value, this.props.InputFormSharePointList);
            this.props.OnInputIsValid(this.state.InputState.InternalName, this.state.InputState.IsValid);

            // Enregistrement des valeurs sélectionnées dans les champs SP correspondants
            let inputPCSModify: IInputFormSharePoint = this.props.InputFormSharePointList[event.target.name];
            if (inputPCSModify != null) {         
                inputPCSModify.Value = event.target.value;
                inputPCSModify.SendToSharePoint = true;
                this.sendInputValueToSharePoint(inputPCSModify);

                if (inputPCSModify.Name == "ProfPCSParent1") {
                  let inputPCSNiveau2: IInputFormSharePoint = this.props.InputFormSharePointList["FonctionParent1"];
                  inputPCSNiveau2.Value = "";
                  inputPCSNiveau2.SendToSharePoint = true;
                  this.sendInputValueToSharePoint(inputPCSNiveau2);
                }
                if (inputPCSModify.Name == "ProfPCSParent2") {
                  let inputPCSNiveau2: IInputFormSharePoint = this.props.InputFormSharePointList["FonctionParent2"];
                  inputPCSNiveau2.Value = "";
                  inputPCSNiveau2.SendToSharePoint = true;
                  this.sendInputValueToSharePoint(inputPCSNiveau2);
                }                
            }   
        }
        else {
            if (this.formValidation(true) || this.state.InputState.Value === "") {
              this.sendInputValueToSharePoint();
            }
        }
    }

    private handleChange(event) {
        if (this.state.InputState.IsReadOnly) {
            return;
        }

        const inputChange = CustomInputService.validInput(this.state.InputState, event.target.value, this.props.InputFormSharePointList);
        if (this.state.InputState.ToUpper && this.state.InputState.Type === "Text") {
          inputChange.Value = event.target.value.toUpperCase();
        }
        if (this.state.InputState.ToUpperFirstLetter && this.state.InputState.Type === "Text") {
          const valeur = event.target.value.split(",");
          var newValue = "";        
          for (let j = 0; j < valeur.length; j++) {
            if (valeur[j].charAt(0) == " ") valeur[j] = valeur[j].slice(1);
            newValue = newValue + valeur[j].charAt(0).toUpperCase() + valeur[j].slice(1) + ", ";
          }
        
          inputChange.Value = newValue.slice(0, newValue.length - 2);

        }

        this.setState({ InputState: inputChange })
        this.inputHaveShowingOther();
    }    

    private handleChangeDate(date) {
        if (this.state.InputState.IsReadOnly) {
            return;
        }

        const dateCast = date as Date;
        if (dateCast != null) {
            dateCast.setHours(8);
            const inputChange = CustomInputService.validInput(this.state.InputState, dateCast, this.props.InputFormSharePointList)
            this.setState({ InputState: inputChange })
            this.inputHaveShowingOther();
            if (this.formValidation(true) || this.state.InputState.Value === "") {
                this.sendInputValueToSharePoint();
            }
        }

    }

    private handleBlur(event) {
        if (this.state.InputState.IsReadOnly) {
            return;
        }

        this.handleSubmit(event);
    }

    private handleSubmit(event) {
        if (this.state.InputState.IsReadOnly) {
            return;
        }

        event.preventDefault();

        if (this.formValidation(true) || this.state.InputState.Value === "") {
            this.sendInputValueToSharePoint();
        }
    }

    private formValidation(changeFirstSubmit: boolean): boolean {
        let isValidForm = true;
        let isFirstSubmit = this.state.IsFirstSubmit;

        if (isFirstSubmit && changeFirstSubmit) {
            isFirstSubmit = false;
        }

        const inputCheck = CustomInputService.validInput(this.state.InputState, this.state.InputState.Value, this.props.InputFormSharePointList);
        if (!inputCheck.IsValid) {
            isValidForm = false;
        }
        this.props.OnInputIsValid(inputCheck.InternalName, inputCheck.IsValid);

        this.setState({ IsValidForm: isValidForm, IsFirstSubmit: isFirstSubmit });

        return isValidForm;
    }

    private sendInputValueToSharePoint(input?: IInputFormSharePoint): void {
        const inputToSave = input != null ? input : this.state.InputState;      

        if (!inputToSave.SendToSharePoint || inputToSave.IsReadOnly) {
            return;
        }

        this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, inputToSave.InternalName, inputToSave.Value, inputToSave.Type).then(result => {
            if (!result.OK) {
                // Retry
                (async () => {
                    // Do something before delay
                    await this.delay(1000);

                    // Do something after
                    this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, inputToSave.InternalName, inputToSave.Value, inputToSave.Type).then(resultTwo => {

                        // If failed
                        if (!resultTwo.OK) {
                            inputToSave.Value = "";
                            inputToSave.IsValid = false;
                            inputToSave.Message = libelle.formulaireInput.errorSaveSharePoint;

                            this.props.OnInputIsValid(inputToSave.InternalName, inputToSave.IsValid);
                            this.setState({ IsValidForm: false, IsFirstSubmit: false });
                            this.props.OnInputChange(inputToSave);
                        }
                    });
                })();
            }
        });

        this.props.OnInputChange(inputToSave);
    }

    private async delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

  //Méthode permettant de gérer l'affichage conditionnel d'autres champs liés à celui en cours de traitement
  private inputHaveShowingOther() {
        if (this.state.InputState.ShowInputWhenValueEquals !== '' && this.state.InputState.ShowInputListId != null) {
           this.state.InputState.ShowInputListId.map(async (key) => {
                //console.log('Gestion de l affichage conditionnel du champ ' + key);
                let inputToShow: IInputFormSharePoint = this.props.InputFormSharePointList[key];
                
                if (this.state.InputState.Value === this.state.InputState.ShowInputWhenValueEquals) {
                    // Si visible on test sa validité
                    inputToShow.IsVisible = true;
                    inputToShow = CustomInputService.validInput(inputToShow, inputToShow.Value, this.props.InputFormSharePointList)
                    this.props.OnInputIsValid(inputToShow.InternalName, inputToShow.IsValid);
                } else {
                    // Si invisible il est dans tous les cas valide
                    inputToShow.IsVisible = false;
                    inputToShow.IsValid = true;
                    inputToShow.Value = "";

                    if (!inputToShow.SendToSharePoint || inputToShow.IsReadOnly) {
                        return;
                    }
                    
                    await this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, inputToShow.InternalName, inputToShow.Value, inputToShow.Type).then(async (result) => {
                        if (!result.OK) {
                            // Retry
                            await this._dataProvider.sendInput(this.props.loginName, this.props.candidatureId, inputToShow.InternalName, inputToShow.Value, inputToShow.Type).then(resultTwo => {
                                // If failed
                                if (!resultTwo.OK) {
                                    inputToShow.Value = "";
                                    inputToShow.IsValid = false;
                                    inputToShow.Message = libelle.formulaireInput.errorSaveSharePoint;
                                }
                            });
                        }
                    });

                    this.props.OnInputIsValid(inputToShow.InternalName, true);
                }

                this.props.OnInputChange(inputToShow);
            });
        }
    }

    /*     private inputSetRequiredFile() {
            const internalName = this.state.InputState.InternalName;
            const matchesEndWithNumber = internalName.match(/\d+$/);
            if (internalName === 'DateNaissance') {
    
                const eventStartTime = new Date(this.state.InputState.Value);
                const eventEndTime = Date.now();
                const duration = eventEndTime.valueOf() - eventStartTime.valueOf();
                const durationYear = duration / (3.1556952 * (Math.pow(10, 10)));
    
                const inputToSetRequired: IInputFormSharePoint = this.props.InputFormSharePointList["PJJustifServiceNational_file"];
    
                this.otherInputToSetRequired(inputToSetRequired, durationYear < 25)
     
            } else if (internalName.lastIndexOf("BoursesN", 0) === 0 && matchesEndWithNumber) {
    
                const inputFileName = "PJJustifBourses" + matchesEndWithNumber[0] + "_file";
                const inputToSetRequired: IInputFormSharePoint = this.props.InputFormSharePointList[inputFileName];
                this.otherInputToSetRequired(inputToSetRequired, this.state.InputState.Value === "Oui")
    
            }
        } 
    
        private otherInputToSetRequired(input: IInputFormSharePoint, isRequired: boolean) {
            if(input == null) {
                return;
            }
    
            if (isRequired) {
                input.InputValidation.IsRequired = true;
                this.props.OnInputIsValid(input.InternalName, input.IsValid);
            } else {
                input.InputValidation.IsRequired = false;
                this.props.OnInputIsValid(input.InternalName, true);
            }
    
            this.props.OnInputChange(input);
        } */

    private firstValidationFormInputSharePoint(): void {

        this.setState({ IsReady: true }, () => {
            this.formValidation(false);
            this.inputHaveShowingOther();
            // this.inputSetRequiredFile();
        });

        this.props.OnInputIsReady(this.state.InputState.InternalName);
    }

}

export default hot(module)(FormulaireInput);
